export default {
  detail: 'Merchant details',
  backpage: 'return to previous page',
  basic: 'merchant information',
  agency: 'agent',
  merchantkey: 'Merchant key',
  indetails: 'Merchant details',
  merchantcode: 'merchant Verify',
  scan: 'Scan the QR code to get the verification code input',
  authcode: 'please enter verification code',
  codenull: 'verification code must be filled',
  label: {
    amount: 'amount',
    merchatNo: 'MerchantNo',
    walletTypeTransferIn: 'TransferIn',
    walletTypeTransferOut: 'TransferOut',
    usdt_qr: 'USDT',
    walletTile: 'wallet details',
    all: 'Total wallet',
    kou: 'Manual deduction',
    recharge: 'Manual recharge',
  },
  rules: {
    amount: {
      required: 'Amount cannot be empty',
      type: 'Amount must be a number',
      typeinteger: 'Amount must be a number,and must be an integer',
      max: 'The amount cannot be greater than the balance'
    },
    remark: {
      required: 'Remarks cannot be empty',
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantdetails.js